import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import cookie from '../../../../helpers/cookie'
import { formatLicenseContent } from '../../../../helpers/license'

class License extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        isLicenseEnabled: PropTypes.bool.isRequired,
        licenseText: PropTypes.string,
    }

    licenseCookieKey = 'license'

    accept = () => {
        // 13 mois selon la CNIL (https://www.cnil.fr/sites/default/files/typo/document/Configuration_piwik.pdf)
        const maxAge = 33696000
        cookie.set(this.licenseCookieKey, 'true', { path: '/', maxAge: maxAge })
        this.forceUpdate()
    }

    render() {
        const { isLicenseEnabled, licenseText, t } = this.props

        const actions = [
            <input
                type="button"
                className="btn primary"
                value={t('visualizer:license.buttons.accept')}
                onClick={this.accept}
            />
        ]

        return (
            <Dialog
                title={t('visualizer:license.title')}
                actions={actions}
                modal={true}
                autoScrollBodyContent={true}
                open={isLicenseEnabled && cookie.get(this.licenseCookieKey) !== 'true'}
            >
                {formatLicenseContent(licenseText)}
            </Dialog>
        );
    }
}

export default withTranslation()(License)
